import * as Yup from "yup";

const versionSchema = Yup.object().shape({
  descripcion: Yup.string().required("Este campo es requerido"),
});

export default versionSchema;
